import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../../shared/pagination-model';

@JsonObject('SalesOrderPollConfigurationFilters')
export class SalesOrderPollConfigurationFilters extends Pagination {
  @JsonProperty('accountString', String, true) accountString: string = undefined;
}
